import React from 'react'

import { ConfirmModal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function DeleteConfirmModal({
  itemType = 'item',
  itemName = '',
  isSubmitDisabled = false,
  onSubmit: handleSubmit,
  onCancel: handleCancel,
}) {
  const t = useTranslation()
  const itemTypeLabel = t(`shared.deleteConfirmModal.itemTypes.${itemType}`)

  return (
    <ConfirmModal
      header={t('shared.deleteConfirmModal.header', { itemType: itemTypeLabel })}
      submitText={t('shared.deleteConfirmModal.submit')}
      cancelText={t('shared.deleteConfirmModal.cancel')}
      isDangerousAction
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    >
      {itemName
        ? t('shared.deleteConfirmModal.bodyNamed', { itemName })
        : t('shared.deleteConfirmModal.bodyGeneric', { itemType: itemTypeLabel })}
    </ConfirmModal>
  )
}

DeleteConfirmModal.propTypes = {
  itemType: string,
  itemName: string,
  isSubmitDisabled: bool,
  onSubmit: func.isRequired,
  onCancel: func.isRequired,
}

export default DeleteConfirmModal
